<template>
  <card id="financial" :class="'bg-card-'+theme">
    <div class="header">
      <h4 class="card-title">Dados Financeiros</h4>
    </div>
    <hr />
    <div class="row" v-if="loadingFinance" v-loading="loadingFinance" id="loading">
    </div>
    <div class="pull-right" v-if="!loadingFinance">
      <button class="btn btn-round btn-fill"
              :class=" theme === 'black' ? 'btn-azure2':'btn-primary' "
              type="submit" v-if="studentSubscriptions.length "
              @click.prevent="handleCreditCardUpdate()">
        Atualizar Cartão
      </button>
      <button class="btn btn-round btn-fill"
              :class=" theme === 'black' ? 'btn-azure2':'btn-primary' "
              type="submit"
              v-if="($auth.user().plan_type_code === 'PREMIUM') && !$auth.user().subscription"
              @click.prevent="handleNewSubscription()">
        Rematrícula
      </button>
    </div>
    <br />
    <div class="table-responsive">
      <div class="row" v-if="loadingFinance" v-loading="loadingFinance" id="loading">
      </div>
      <table class="table" :class="'card-title-'+theme" v-if="!loadingFinance">
        <tr>
          <th width="20%">Produto</th>
          <th width="10%">Data</th>
          <th width="10%">Valor</th>
          <th width="20%">Próxima Cobrança</th>
          <th width="10%">Status</th>
          <th width="20%">Ações</th>
        </tr>
        <tr v-for="(studentSubscription, index) in studentSubscriptions" :key="index">
          <td width="20%">{{studentSubscription.plan.name}}</td>
          <td width="10%">{{studentSubscription.start_at}}</td>
          <td width="10%">{{studentSubscription.product_items[0].pricing_schema.short_format}}</td>
          <td width="20%">{{studentSubscription.next_billing_at}}</td>
          <td width="10%">
            {{studentSubscription.status === 'active' ? 'Ativo' : ''}}
            {{studentSubscription.status === 'canceled' ? 'Cancelado' : ''}}
          </td>
          <td width="20%">
            <ul style="list-style-type:none">
              <li>
                <button v-show="studentSubscription.status==='active' && ($auth.user().plan_type_code !== 'START' && $auth.user().plan_type_code !== 'PLUS')" class="btn btn-danger btn-fill btn-sm" type="submit" @click.prevent="handleCancelSubscription(studentSubscription)">
                  Cancelar
                </button>
                <button v-show="studentSubscription.status==='canceled'" class="btn btn-success btn-fill btn-sm" type="submit" @click.prevent="handleReactivateSubscription(studentSubscription)">
                  Renovar
                </button>
              </li>
            </ul>
          </td>
        </tr>
      </table>
      <el-dialog center title="Deseja realmente cancelar assinatura ?" :visible.sync="modals.cancel">
        <div class="row" v-if="loadingCancelStudentSubscription" v-loading="loadingCancelStudentSubscription" id="loading">
        </div>
        <div class="col-md-12" v-if="!loadingCancelStudentSubscription">
          <hr />
          <form class="text-center col-md-12">
            <div>
              <h4 class="title" style="white-space: pre-wrap; word-break: keep-all;">
                Ao cancelar esta assinatura, você não poderá renová-la com os mesmo BENEFÍCIOS promocionais.
              </h4>
              <br />
              <div>
                <button class="btn btn-danger btn-fill btn-wd" type="submit" @click.prevent="cancelStudentSubscription()">
                  Cancelar
                </button>
              </div>
            </div>
            <div class="clearfix"></div>
          </form>
          <hr />
        </div>
      </el-dialog>
      <el-dialog center title="Deseja renovar sua assinatura ?" :visible.sync="modals.reactivate">
        <div class="row" v-if="loadingReactivateStudentSubscription" v-loading="loadingReactivateStudentSubscription" id="loading">
        </div>
        <div class="col-md-12" v-if="!loadingReactivateStudentSubscription">
          <hr />
          <form class="text-center col-md-12">
            <div>
              <h4 class="title" style="white-space: pre-wrap; word-break: keep-all;">Ao renovar esta assinatura, você voltará a ter todos os benefícios que seu plano possui.
              </h4>
              <br />
              <div>
                <button class="btn btn-danger btn-fill btn-wd" type="submit" @click.prevent="reactivateStudentSubscription()">
                  Renovar
                </button>
              </div>
            </div>
            <div class="clearfix"></div>
          </form>
          <hr />
        </div>
      </el-dialog>
      <el-dialog center title="Nova Assinatura" :visible.sync="modals.newSubscription">
        <div class="row" v-if="loadingSubscriptionPlan" v-loading="loadingSubscriptionPlan" id="loading">
        </div>
        <div class="col-md-12" v-if="!loadingSubscriptionPlan">
          <div class="row">
            <div class="col-md-6">
              <h5 class="card-title pull-left">{{ subscriptionPlan.name }}</h5>
            </div>
            <div class="col-md-6 col-sm-12">
              <h5 class="card-title text-center pull-right" v-for="planItem in subscriptionPlan.plan_items" :key="planItem.id">
                <small> {{ planItem.product.name }}. {{ !planItem.cycles ? "Mensal" : planItem.cycles + "x" }} -</small>
                {{ planItem.product.pricing_schema.short_format }} <br>
              </h5>
            </div>
          </div>
          <hr />
          <form>
            <div class="row">
              <div class="col-md-4 col-sm-12">
                <label>Cartão de Crédito: </label>
                <br />
                <el-select class="select-primary col-md-12" required size="large" v-model="customerProfile.customer_card_type" placeholder="Selecione..." @change="setCreditCardType()">
                  <el-option v-for="(option) in cardTypes" class="select-danger" :value="option" :label="option" :key="option"></el-option>
                </el-select>
              </div>
              <div class="col-md-8 col-sm-12">
                <br>
                <img class="pull-right" src="static/img/card-buy.png" alt="logo">
              </div>
            </div>
            <br>
            <div class="row">
              <div class="col-md-6 col-sm-12">
                <fg-input type="text" label="Número do cartão:" v-mask="''+creditCardMask" v-model="customerProfile.customer_card_number">
                </fg-input>
              </div>
              <div class="col-md-6 col-sm-12">
                <fg-input type="text" id="the-card-name-id" label="Nome do titular:" placeholder="Como consta no cartão" v-model="customerProfile.customer_card_name">
                </fg-input>
              </div>
            </div>
            <div class="row col-md-12 col-sm-12">
              <div class="col-md-4">
                <label>Mês de Vencimento: </label>
                <br />
                <el-select class="select-primary col-md-12" required size="large" v-model="customerProfile.customer_card_expiry_month" placeholder="Selecione...">
                  <el-option v-for="(option) in monthsOfTheYear" class="select-danger" :value="option" :label="option" :key="option"></el-option>
                </el-select>
              </div>
              <div class="col-md-4 col-sm-12">
                <label>Ano  de Vencimento: </label>
                <br />
                <el-select class="select-primary col-md-12" required size="large" v-model="customerProfile.customer_card_expiry_year" placeholder="Selecione...">
                  <el-option v-for="(option) in TenYearsFromNow" class="select-danger" :value="option" :label="option" :key="option"></el-option>
                </el-select>
              </div>
              <div class="col-md-4 col-sm-12">
                <label>Cod. Segurança: </label>
                <br />
                <fg-input type="text" class="col-md-12" minlength="3" maxlength="4" v-mask="''+cvcMask" v-model="customerProfile.customer_card_cvc" placeholder="3 ou 4 Digítos">
                </fg-input>
              </div>
            </div>
            <div class="text-danger">
              <p class="text-left" v-if="formErrors.length">
                <b>Por favor, corrija o(s) seguinte(s) erro(s):</b>
                <ul>
                  <li v-for="error in formErrors" :key="error">{{ error }}</li>
                </ul>
              </p>
            </div>
            <div class="clearfix"></div>
            <div>
              <button class="btn btn-primary btn-fill btn-wd pull-right" type="submit" @click.prevent="submitNewSubscription()">
                Assinar
              </button>
            </div>
          </form>
          <br>
        </div>
      </el-dialog>
      <el-dialog center title="Atualizar Cartão de Crédito" :visible.sync="modals.creditCardUpdate">
        <div class="row" v-if="loadingCreditCardUpdate" v-loading="loadingCreditCardUpdate" id="loading">
        </div>
        <div class="col-md-12" v-if="!loadingCreditCardUpdate">
          <form>
            <div class="row">
              <div class="col-md-4 col-sm-12">
                <label>Cartão de Crédito: </label>
                <br />
                <el-select class="select-primary col-md-12" required size="large" v-model="customerProfile.customer_card_type" placeholder="Selecione..." @change="setCreditCardType()">
                  <el-option v-for="(option) in cardTypes" class="select-danger" :value="option" :label="option" :key="option"></el-option>
                </el-select>
              </div>
              <div class="col-md-8 col-sm-12">
                <br>
                <img class="pull-right" src="static/img/card-buy.png" alt="logo">
              </div>
            </div>
            <br>
            <div class="row">
              <div class="col-md-6 col-sm-12">
                <fg-input type="text" label="Número do cartão:" v-mask="''+creditCardMask" v-model="customerProfile.customer_card_number">
                </fg-input>
              </div>
              <div class="col-md-6 col-sm-12">
                <fg-input type="text" id="the-card-name-id" label="Nome do titular:" placeholder="Como consta no cartão" v-model="customerProfile.customer_card_name">
                </fg-input>
              </div>
            </div>
            <div class="row col-md-12 col-sm-12">
              <div class="col-md-4">
                <label>Mês de Vencimento: </label><br />
                <el-select class="select-primary col-md-12" required size="large" v-model="customerProfile.customer_card_expiry_month" placeholder="Selecione...">
                  <el-option v-for="(option) in monthsOfTheYear" class="select-danger" :value="option" :label="option" :key="option"></el-option>
                </el-select>
              </div>
              <div class="col-md-4 col-sm-12">
                <label>Ano de Vencimento: </label><br />
                <el-select class="select-primary col-md-12" required size="large" v-model="customerProfile.customer_card_expiry_year" placeholder=" Selecione...">
                  <el-option v-for="(option) in TenYearsFromNow" class="select-danger" :value="option" :label="option" :key="option"></el-option>
                </el-select>
              </div>
              <div class="col-md-4 col-sm-12">
                <label>Cod. Segurança: </label><br />
                <fg-input type="text" class="col-md-12" minlength="3" maxlength="4" v-mask="''+cvcMask" v-model="customerProfile.customer_card_cvc" placeholder="3 ou 4 Digítos">
                </fg-input>
              </div>
            </div>
            <div class="text-danger">
              <p class="text-left" v-if="formErrors.length">
                <b>Por favor, corrija o(s) seguinte(s) erro(s):</b>
                <ul>
                  <li v-for="error in formErrors" :key="error">{{ error }}</li>
                </ul>
              </p>
            </div>
            <div class="clearfix"></div>
            <div>
              <button class="btn btn-primary btn-fill btn-wd pull-right" type="submit" @click.prevent="submitCreditCardUpdate()">
                Atualizar
              </button>
            </div>
          </form>
          <br>
        </div>
      </el-dialog>
    </div>
  </card>
</template>
<script>
import Vue from 'vue'
import swal from 'sweetalert2'
import { Loading, Select, Dialog, Option } from 'element-ui'
import { mask } from 'vue-the-mask'
import moment from 'moment-timezone'

// Utilities
import { BrazilianStates } from 'src//utils/modals/brazilian-states'
import { Countries } from 'src/utils/modals/countries'
import { Jobs } from 'src/utils/modals/jobs'

Vue.use(Loading.directive)
moment.tz.setDefault('America/Sao_Paulo')
Vue.use(require('vue-moment'))

export default {
  components: {
    [Select.name]: Select,
    [Dialog.name]: Dialog,
    [Option.name]: Option
  },
  directives: { mask },
  data () {
    return {
      loadingStudent: false,
      loadingFinance: false,
      loadingSubscriptionPlan: false,
      loadingCancelStudentSubscription: false,
      loadingReactivateStudentSubscription: false,
      loadingCreditCardUpdate: false,
      userPassword: {
        password: '',
        password_confirmation: ''
      },
      userProfile: {
        name: '',
        surname: '',
        email: ''
      },
      studentProfile: {
        gender: '',
        job: '',
        cpf: '',
        birthdate: '',
        cellphone: '',
        telegram: '',
        cep: '',
        address: '',
        address_complement: '',
        address_number: '',
        city: '',
        state: '',
        country: '',
        is_foreign_country: '',
        facebook_link: ''
      },
      formErrors: [],
      monthsOfTheYear: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      TenYearsFromNow: [],
      cardTypes: [
        'visa',
        'mastercard',
        'diners_club',
        'american_express',
        'elo'
      ],
      creditCardMask: '',
      cvcMask: '',
      customerProfile: {
        operation_type: 'NEW_CUSTOMER_SUBSCRIPTION',
        plan_id: '',
        customer_card_number: '',
        customer_card_type: '',
        customer_card_name: '',
        customer_card_expiry_month: '',
        customer_card_expiry_year: '',
        customer_card_cvc: ''
      },
      studentSubscriptions: {},
      studentSubscriptionId: '',
      subscriptionPlan: {},
      selects: {
        genders: [
          { value: 'M', label: 'Masculino' },
          { value: 'F', label: 'Feminino' },
          { value: 'N', label: 'Prefiro não Informar' }
        ],
        isForeignCountry: [
          { value: 1, label: 'Sim' },
          { value: 0, label: 'Não' }
        ]
      },
      modals: {
        newSubscription: false,
        creditCardUpdate: false,
        cancel: false,
        reactivate: false
      },
      jobs: Jobs,
      countries: Countries,
      states: BrazilianStates.estados,
      stateIndex: 0
    }
  },
  methods: {
    notifyVue (message, verticalAlign, horizontalAlign, color, icon) {
      this.$notify(
        {
          component: {
            template: `<h5 class="card-title">${message}</h5>`
          },
          icon: 'nc-icon ' + icon,
          horizontalAlign: horizontalAlign,
          verticalAlign: verticalAlign,
          type: color
        })
      },
    fetchUser () {
      this.$auth.fetch({
        params: {},
        success: function () {
          this.userProfile.name = this.$auth.user().name
          this.userProfile.surname = this.$auth.user().surname
          this.userProfile.email = this.$auth.user().email
        },
        error: function (error) {
          console.log(error)
          alert('Erro ao recarregar usuário. Tente novamente \n. ' + error)
        }
      })
    },
    fetchStudent () {
      this.loadingStudent = true
      this.axios
      .get('/student/' + this.$auth.user().userable_id)
      .then(response => {
        this.loadingStudent = false
        if (response.data.data) {
          this.studentProfile = response.data.data
        }
      })
      .catch(error => {
        this.loadingStudent = false
        console.log(error)
        alert('Erro ao carregar dados do aluno. Tente novamente \n. ' + error)
      })
    },
    fetchStudentSubscriptions () {
      this.loadingFinance = true
      this.axios
      .get('/vindi/student/subscriptions')
      .then(response => {
        this.loadingFinance = false
        if (response.data) {
          this.studentSubscriptions = response.data
          this.studentSubscriptions.forEach(subscription => {
            subscription.start_at = moment(subscription.start_at).format('DD/MM/YYYY')
            subscription.next_billing_at ? subscription.next_billing_at = moment(subscription.next_billing_at).format('DD/MM/YYYY') : subscription.next_billing_at = '-'
          })
        }
      })
      .catch(error => {
        this.loadingFinance = false
        console.log(error)
      })
    },
    fetchSubscriptionPlan () {
    this.loadingSubscriptionPlan = true
    const planID = process.env.VUE_APP_VINDI_PLANPREMIUMREMATRICULA
    this.axios
      .get('/vindi/' + planID)
      .then(response => {
        if (response.data) {
          this.loadingSubscriptionPlan = false
          this.subscriptionPlan = response.data
          this.customerProfile.plan_id = this.subscriptionPlan.id
        } else {
          swal({
            title: 'Falha ao carregar dados de inscrição!',
            text: 'Tente Novamente',
            type: 'error',
            confirmButtonText: 'Ok! Recarregar Página',
            confirmButtonColor: '#FB404B'
          }).then(result => {
            setTimeout(function () {
              location.reload()
            }, 100)
          })
        }
      })
    },
    submitUserProfileUpdate () {
      this.loadingStudent = true
      this.axios
      .patch('/student/userupdate', this.userProfile)
      .then(response => {
        this.loadingStudent = false
        this.notifyVue('Dados de Usuário alterados com sucesso', 'top', 'center', 'primary', 'nc-check-2')
        this.fetchUser()
      })
      .catch(error => {
        this.loadingStudent = false
        console.log(error)
        alert('Erro ao salvar dados de usuário. Tente novamente \n. ' + error)
      })
    },
    submitStudentProfileUpdate () {
      this.loadingStudent = true
      this.axios
      .patch('/student/infoupdate', this.studentProfile)
      .then(response => {
        this.loadingStudent = false
        this.notifyVue('Dados Pessoais alterados com sucesso', 'top', 'center', 'primary', 'nc-check-2')
      })
      .catch(error => {
        this.loadingStudent = false
        console.log(error)
        alert('Erro ao salvar alterações. Verifique se todos os campos foram preenchidos com informações válidas')
      })
    },
    submitStudentPasswordUpdate () {
      this.loadingStudent = true
      this.axios
      .patch('/student/userpwdupdate', this.userPassword)
      .then(response => {
        this.loadingStudent = false
        this.notifyVue('Senha Alterada com sucesso', 'top', 'center', 'primary', 'nc-check-2')
        this.userPassword.password = ''
        this.userPassword.password_confirmation = ''
      })
      .catch(error => {
        this.loadingStudent = false
        this.userPassword.password = ''
        this.userPassword.password_confirmation = ''
        console.log(error)
        alert('Erro ao alterar senha. Certifique-se que as senhas possuem ao menos 6 caracteres e são iguais: ' + error)
      })
    },
    submitNewSubscription () {
      this.formErrors = []

      if (!this.customerProfile.customer_card_number ||
        !this.customerProfile.customer_card_type ||
        !this.customerProfile.customer_card_name ||
        !this.customerProfile.customer_card_expiry_month ||
        !this.customerProfile.customer_card_expiry_year ||
        !this.customerProfile.customer_card_cvc
      ) {
        this.formErrors.push(
          'Todos os campos devem ser preenchidos obrigatoriamente.'
        )
      }

      if (!this.formErrors.length) {
        this.loadingSubscriptionPlan = true

        var paymentProfile = {
          holder_name: this.customerProfile.customer_card_name,
          card_expiration:
          this.customerProfile.customer_card_expiry_month +
          '/' +
          this.customerProfile.customer_card_expiry_year,
          card_number: this.customerProfile.customer_card_number,
          card_cvv: this.customerProfile.customer_card_cvc,
          payment_method_code: 'credit_card',
          payment_company_code: this.customerProfile.customer_card_type
        }

        // set vindi's public key.
        const VINDI_PUBKEY = process.env.VUE_APP_VINDI_PUBKEY
        const VINDI_URL = process.env.VUE_APP_VINDI_URL

        this.axios({
          method: 'post',
          url: VINDI_URL + 'public/payment_profiles',
          dataType: 'json',
          headers: {
            Authorization:
            'Basic ' + btoa(VINDI_PUBKEY + ':')
          },
          data: paymentProfile
        })
        .then(response => {
          delete this.customerProfile.customer_card_name
          delete this.customerProfile.customer_card_number
          delete this.customerProfile.customer_card_cvc
          delete this.customerProfile.customer_card_expiry_month
          delete this.customerProfile.customer_card_expiry_year
          delete this.customerProfile.customer_card_type

          this.customerProfile = { ...this.customerProfile, ...response.data.payment_profile }

          this.axios
          .patch('/vindi/student/subscriptions/new', this.customerProfile)
          .then(response => {
            this.loadingSubscriptionPlan = false
            this.closeModal('newSubscription')
            if (response.status == '200') {
              swal({
                title: 'Inscrição realizada com sucesso!',
                text: 'Aguarde a confirmação de pagamento para continuar aproveitando o melhor conteúdo trader do Brasil.',
                type: 'success',
                confirmButtonText: 'Ok!',
                confirmButtonColor: '#002c44'
              })
              this.fetchStudentSubscriptions()
            }
          })
          .catch(error => {
            this.loadingSubscriptionPlan = false
            this.closeModal('newSubscription')
            swal({
              title: 'Falha ao processar inscrição!',
              text: 'Entre em contato com o suporte.',
              type: 'error',
              confirmButtonText: 'Ok! Ir para Chat',
              confirmButtonColor: '#FB404B'
            }).then(result => {
              setTimeout(function () {
                window.location.href = 'https://api.whatsapp.com/send?phone=5591991133258'
              }, 100)
            })
          })
        })
        .catch(error => {
          this.loadingSubscriptionPlan = false
          this.closeModal('newSubscription')
          swal({
            title: 'Cartão Recusado!',
            text:
            'Verifique os dados de pagamento ou entre em contato com sua administradora de cartões',
            type: 'error',
            confirmButtonText: 'Ok! Tentar Novamente',
            confirmButtonColor: '#FB404B'
          })
          console.log(error)
        })
      }
    },
    submitCreditCardUpdate () {
      this.formErrors = []

      if (!this.customerProfile.customer_card_number ||
        !this.customerProfile.customer_card_type ||
        !this.customerProfile.customer_card_name ||
        !this.customerProfile.customer_card_expiry_month ||
        !this.customerProfile.customer_card_expiry_year ||
        !this.customerProfile.customer_card_cvc
      ) {
        this.formErrors.push(
          'Todos os campos devem ser preenchidos obrigatoriamente.'
        )
      }

      if (!this.formErrors.length) {
        this.loadingCreditCardUpdate = true

        var paymentProfile = {
          holder_name: this.customerProfile.customer_card_name,
          card_expiration:
          this.customerProfile.customer_card_expiry_month +
          '/' +
          this.customerProfile.customer_card_expiry_year,
          card_number: this.customerProfile.customer_card_number,
          card_cvv: this.customerProfile.customer_card_cvc,
          payment_method_code: 'credit_card',
          payment_company_code: this.customerProfile.customer_card_type
        }

        // set vindi's public key.
        const VINDI_PUBKEY = process.env.VUE_APP_VINDI_PUBKEY
        const VINDI_URL = process.env.VUE_APP_VINDI_URL

        this.axios({
          method: 'post',
          url: VINDI_URL + 'public/payment_profiles',
          dataType: 'json',
          headers: {
            Authorization:
            'Basic ' + btoa(VINDI_PUBKEY + ':')
          },
          data: paymentProfile
        })
        .then(response => {
          this.loadingCreditCardUpdate = false
          this.closeModal('creditCardUpdate')
          if (response.status == '200') {

            delete this.customerProfile.customer_card_name
            delete this.customerProfile.customer_card_number
            delete this.customerProfile.customer_card_cvc
            delete this.customerProfile.customer_card_expiry_month
            delete this.customerProfile.customer_card_expiry_year
            delete this.customerProfile.customer_card_type

          this.axios
          .patch('/vindi/student/payment_profile/update', this.customerProfile)
          .then(response => {
            this.loadingCreditCardUpdate = false
            this.closeModal('creditCardUpdate')
            if (response.status == '200') {
              swal({
                title: 'Atualização realizada com sucesso!',
                text: 'Faturas em atraso serão cobradas automaticamente.',
                type: 'success',
                confirmButtonText: 'Ok! Continuar utilizando plataforma',
                confirmButtonColor: '#002c44'
              })
              this.fetchStudentSubscriptions()
            }
          })
          .catch(error => {
            this.loadingCreditCardUpdate = false
            this.closeModal('creditCardUpdate')
            swal({
              title: 'Falha ao processar dados!',
              text: 'Entre em contato com o suporte.',
              type: 'error',
              confirmButtonText: 'Ok! Ir para Chat',
              confirmButtonColor: '#FB404B'
            }).then(result => {
              setTimeout(function () {
                window.location.href = 'https://api.whatsapp.com/send?phone=5591991133258'
              }, 100)
            })
          })
        }
      })
        .catch(error => {
          this.loadingCreditCardUpdate = false
          this.closeModal('creditCardUpdate')
          swal({
            title: 'Cartão Recusado!',
            text:
            'Verifique os dados de pagamento ou entre em contato com sua administradora de cartões.',
            type: 'error',
            confirmButtonText: 'Ok! Ir para Chat',
            confirmButtonColor: '#FB404B'
          }).then(result => {
            setTimeout(function () {
              window.location.href = 'https://api.whatsapp.com/send?phone=5591991133258'
            }, 100)
          })
        })
      }
    },
    setStateIndex () {
      let index = 0
      this.studentProfile.city = ''
      for (let state of this.states) {
        if (state.nome === this.studentProfile.state) {
          this.stateIndex = index
        }
        index++
      }
    },
    setCreditCardType () {
      switch (this.customerProfile.customer_card_type) {
        case 'visa':
        this.creditCardMask = 'XXXX XXXX XXXX XXXX'
        this.cvcMask = 'XXX'
        break
        case 'mastercard':
        this.creditCardMask = 'XXXX XXXX XXXX XXXX'
        this.cvcMask = 'XXX'
        break
        case 'diners_club':
        this.creditCardMask = 'XXXX XXXXXX XXXX'
        this.cvcMask = 'XXX'
        break
        case 'american_express':
        this.creditCardMask = 'XXXX XXXXXX XXXXX'
        this.cvcMask = 'XXXX'
        break
        case 'elo':
        this.creditCardMask = 'XXXX XXXX XXXX XXXX'
        this.cvcMask = 'XXX'
        break
      }
    },
    openModal (name) {
      this.modals[name] = true
    },
    closeModal (name) {
      this.modals[name] = false
    },
    handleNewSubscription () {
      this.fetchSubscriptionPlan()
      this.TenYearsFromNow = []
      for (var i = parseInt(new Date().getFullYear(), 10); i <= parseInt(new Date().getFullYear(), 10) + 10; i++) {
        this.TenYearsFromNow.push(i)
      }
      this.openModal('newSubscription')
    },
    handleCreditCardUpdate () {
      this.TenYearsFromNow = []
      for (var i = parseInt(new Date().getFullYear(), 10); i <= parseInt(new Date().getFullYear(), 10) + 10; i++) {
        this.TenYearsFromNow.push(i)
      }
      this.openModal('creditCardUpdate')
    },
    handleCancelSubscription (studentSubscription) {
      this.studentSubscriptionId = studentSubscription.id
      this.openModal('cancel')
    },
    handleReactivateSubscription (studentSubscription) {
      this.studentSubscriptionId = studentSubscription.id
      this.openModal('reactivate')
    },
    showSwal (title, message, buttonClass, type) {
      swal({
        title: title,
        text: message,
        confirmButtonClass: buttonClass,
        type: type
      })
    },
    cancelStudentSubscription () {
      this.loadingCancelStudentSubscription = true
      this.axios
        .get('/vindi/student/subscriptions/cancel/' + this.studentSubscriptionId)
        .then(response => {
          this.closeModal('cancel')
          this.loadingCancelStudentSubscription = false
          if (response.data) {
            this.showSwal('Assinatura cancelada com sucesso!', '', 'btn btn-primary btn-fill', 'success')
            this.fetchStudentSubscriptions()
          }
        })
        .catch(error => {
          this.closeModal('cancel')
          this.loadingCancelStudentSubscription = false
          console.log(error)
          this.showSwal('Erro ao cancelar assinatura!', 'Entre em contato com o suporte', 'btn btn-primary btn-fill', 'error')
        })
    },
    reactivateStudentSubscription () {
      this.loadingReactivateStudentSubscription = true
      this.axios
        .get('/vindi/student/subscriptions/reactivate/' + this.studentSubscriptionId)
        .then(response => {
          this.closeModal('reactivate')
          this.loadingReactivateStudentSubscription = false
          if (response.data) {
            this.showSwal('Assinatura renovada com sucesso!', '', 'btn btn-primary btn-fill', 'success')
            this.fetchStudentSubscriptions()
          }
        })
        .catch(error => {
          this.closeModal('reactivate')
          this.loadingReactivateStudentSubscription = false
          console.log(error)
          this.showSwal('Erro ao renovar a assinatura!', 'Entre em contato com o suporte', 'btn btn-primary btn-fill', 'error')
        })
    }

    },
    computed: {
      theme() {
        return this.$auth.user().layout;
      }
    },
    created () {
      this.fetchUser()
      this.fetchStudent()
      this.fetchStudentSubscriptions()
    }
  }

  </script>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/Signature.vue